import { AppointmentAnalyticsTypes } from '@frontend/api-analytics';
import { AnalyticsUtils } from '@frontend/analytics-shared';

const providers = AnalyticsUtils.demoDataUtils.generateRandomUserNames(10);

const pmList = [
  '4BWX',
  'ProphyAd',
  'PeriodicX',
  'ProphyCh',
  'TopFlride',
  '##',
  'DL',
  'INS',
  'Card',
  '5DiTero',
  'CompEx',
  'FMX',
  'Pano',
  'DiagCasts',
];

function generateRandomPMType() {
  const shuffled = pmList.sort(() => 0.5 - Math.random());
  return shuffled.slice(0, 3).join(', ');
}

export const tableData: AppointmentAnalyticsTypes.AppointmentReportResponse = {
  data: {
    Data: AnalyticsUtils.demoDataUtils.generateRandomUserNames(25).map(({ firstName, lastName }) => {
      const weaveStatus = ['Attempted', 'Canceled', 'Completed', 'Confirmed', 'Unconfirmed', 'Unknown'][
        Math.floor(Math.random() * 6)
      ];

      let pmsStatus = 'Unknown';

      switch (weaveStatus) {
        case 'Attempted':
          pmsStatus = 'No Answer';
          break;
        case 'Canceled':
          pmsStatus = 'Left Message';
          break;
        case 'Completed':
          pmsStatus = 'Done';
          break;
        case 'Confirmed':
          pmsStatus = 'Confirmed';
          break;
        case 'Unconfirmed':
          pmsStatus = 'Unscheduled/broken appointment';
          break;
      }

      const provider = providers[Math.floor(Math.random() * providers.length)];

      // Randomly pick a few and join them with comma to form the pm type
      const typePM = generateRandomPMType();

      return {
        ID: AnalyticsUtils.demoDataUtils.generateRandomUUID(),
        LocationID: AnalyticsUtils.demoDataUtils.dummyLocationId,
        AppointmentID: AnalyticsUtils.demoDataUtils.generateRandomUUID(),
        PersonID: AnalyticsUtils.demoDataUtils.generateRandomUUID(),
        AppointmentPMID: AnalyticsUtils.demoDataUtils.generateRandomNumberString(5),
        Length: Math.floor(Math.random() * 30),
        Operatory: AnalyticsUtils.demoDataUtils.generateRandomNumberString(3),
        StatusWithModifiedTime: [
          {
            Status: weaveStatus,
            ModifiedTime: AnalyticsUtils.demoDataUtils.generateRandomDate(weaveStatus !== 'Completed'),
          },
        ],
        StatusPMWithModifiedTime: [
          {
            Status: pmsStatus,
            ModifiedTime: AnalyticsUtils.demoDataUtils.generateRandomDate(pmsStatus !== 'Done'),
          },
        ],
        ConfirmationStatusWithModifiedTime: [],
        TypePM: typePM,
        EntryDate: AnalyticsUtils.demoDataUtils.generateRandomDate(),
        SourceID: AnalyticsUtils.demoDataUtils.generateRandomUUID(),
        AppointmentDate: AnalyticsUtils.demoDataUtils.generateRandomDate(true),
        Provider: `${provider.firstName} ${provider.lastName}`,
        ModifiedAt: AnalyticsUtils.demoDataUtils.generateRandomDate(),
        CancelDate: AnalyticsUtils.demoDataUtils.generateRandomDate(),
        ClientLocationID: AnalyticsUtils.demoDataUtils.dummyLocationId,
        LocationName: 'Location 1',
        PatientID: AnalyticsUtils.demoDataUtils.generateRandomNumberString(4),
        PatientName: `${firstName} ${lastName}`,
        PhoneNumber: AnalyticsUtils.demoDataUtils.generateRandomNumberString(10),
        TimeZone: 'US/Central',
        AppointmentCategory: ['Retained', 'New Patient', 'Existing'][Math.floor(Math.random() * 3)],
      };
    }),
  },
  meta: {
    links: {
      next: '',
      previous: '',
    },
  },
};
